module.exports = __webpack_public_path__ + "static/media/techlead2.f2b994d4.jpg";